import type { PageTourDefinition, PageTourStep } from '../../components/tour/pageTourTypes';
import { ROUTES } from '../routes';

/** Pasos del tour en el listado `/ventas/cotizaciones`. */
const COTIZACIONES_LISTADO_STEPS: PageTourStep[] = [
  {
    targetId: 'cotizaciones-nueva-pos',
    title: 'Nueva cotización POS',
    body: 'Desde acá armás una cotización: elegís cliente, agregás artículos y la guardás para enviarla, prepararla o facturarla después.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'cotizaciones-importar',
    title: 'Importar carpeta',
    body: 'Importá cotizaciones en bloque desde archivos PDF de una carpeta, eligiendo la sucursal de destino.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'cotizaciones-filtros',
    title: 'Filtros de búsqueda',
    body: 'Filtrá por número, cliente, estado, rango de fechas o sucursal para encontrar cotizaciones rápido.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'cotizaciones-kpis',
    title: 'Resumen del período',
    body: 'Estos indicadores resumen cantidad, totales, peso y volumen de las cotizaciones según los filtros aplicados.',
    placement: 'bottom',
    pad: 4,
  },
  {
    targetId: 'cotizaciones-grilla',
    title: 'Listado de cotizaciones',
    body: 'Acá ves las cotizaciones con su estado. Tocá el comprobante para abrirla en el POS.',
    placement: 'top',
    pad: 4,
  },
  {
    targetId: 'cotizaciones-acciones',
    title: 'Acciones por cotización',
    body: 'Desde cada fila podés imprimir, preparar la cotización como pedido, facturarla o usar el menú ⋮ para ver el detalle, editarla o anularla.',
    placement: 'left',
    pad: 6,
  },
];

/** Pasos del tour en el POS `/ventas/cotizaciones/nuevo-pos`. */
const COTIZACIONES_POS_STEPS: PageTourStep[] = [
  {
    targetId: 'pos-cliente',
    title: 'Cliente',
    body: 'Seleccioná el cliente de la cotización. Los precios se toman de su lista de precios.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'pos-busqueda',
    title: 'Agregar artículos',
    body: 'Buscá productos y agregalos a la cotización. Si está habilitado, también podés precargarla desde un PDF.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'pos-lineas',
    title: 'Artículos de la cotización',
    body: 'Editá cantidades, precios y descuentos de cada renglón. Podés duplicar o eliminar líneas según necesites.',
    placement: 'top',
    pad: 4,
  },
  {
    targetId: 'pos-totales',
    title: 'Totales y datos de la cotización',
    body: 'Revisá descuentos, IVA y total. Completá fechas, compañía, vendedor, lista de precios y datos de entrega.',
    placement: 'left',
    pad: 4,
  },
  {
    targetId: 'pos-emitir',
    title: 'Guardar cotización',
    body: 'Cuando esté todo listo, guardá la cotización. Después la encontrás en el listado para imprimirla, prepararla o facturarla.',
    placement: 'top',
    pad: 8,
  },
];

export const COTIZACIONES_LISTADO_TOUR: PageTourDefinition = {
  id: 'cotizaciones-listado',
  steps: COTIZACIONES_LISTADO_STEPS,
  continueTo: `${ROUTES.ventas.cotizaciones.pos}?tour=1`,
  continueLabel: 'Ir al POS',
  continuePermiso: 'ventas.cotizaciones.nuevo',
};

export const COTIZACIONES_POS_TOUR: PageTourDefinition = { id: 'cotizaciones-pos', steps: COTIZACIONES_POS_STEPS };
